import React from 'react';
import { connect } from 'react-redux';
import { chartDataFactory } from '@/chart/charts/chart-data-builders';
import { CHART_TO_COMPONENT as Chart } from '@/chart/components/all-charts';
import Header from '@/chart/components/header';
import * as dataSelectors from '@/data/data-selectors';
import styled from 'styled-components';

const DashboardPrintWrapper = styled.div`
  background-color: 'white';
  width: 650px;
  height: 450px;
`;

const InvisibleUntilPrint = styled.div`
  width: 100%;
  height: 100%;
  .invisi-until-print {
    display: none;
  }

  @media print {
    .invisi-until-print {
      display: block;
    }
  }
`;

const StyledSeparator = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  width: 650px;
`;

const ChartWrapper = styled.div`
  height: 300px;
  margin-bottom: 12px;
`;

const datasetTypeToLabels = {
  CURRENT_STR_PROPERTIES: ['STR Properties'],
  OCCUPANCY: ['Occupancy'],
  AVG_DAILY_RATE: ['ADR'],
  REVENUE: ['Revenue'],
  TRANSIENT_OCCUPANCY_TAX: ['Estimated', 'Actual'],
  REGISTRATION_RATE: ['Registration Rate'],
  RENTAL_TYPE: ['Full Unit', 'Partial', 'Unknown'], // stats about types of rental properties
  RESIDENTIAL_TYPE: ['Primary', 'Sec/Invest', 'Unknown'], // stats about types of residential properties
  ONLINE_PLATFORMS: ['Airbnb', 'Vrbo', 'Homeaway', 'Others'], // stats about platforms such as airbnb
  RENTAL_SIZE: ['STU/1R', '2R', '3R', '4R+'],
  RENTAL_STRUCTURE: ['Main Structure', 'ADU', 'Multifamily', 'Unknown'],
};

// TODO: All the sizing here is hard coded b/c of time. Need to clean this up...
function ChartAxisValues(props) {
  const { dataPoints, label } = props;
  return (
    <div className="invisi-until-print">
      <div
        style={{
          display: 'flex',
          width: 680,
          flexDirection: 'row',
          padding: '4px 0px 4px 0px',
        }}
      >
        <div style={{ fontSize: 10, width: 75 }}>{label}</div>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          {dataPoints.map((point, i) => (
            <div style={{ fontSize: 10, width: 100 }} key={i}>
              {point}
            </div>
          ))}
        </div>
      </div>
      <StyledSeparator />
    </div>
  );
}

function constructAxisValues(chartData, chartType) {
  const { datasets } = chartData;
  // Always an array of labels
  const labels = datasetTypeToLabels[chartType];
  return datasets.map((dataset, i) => (
    <ChartAxisValues dataPoints={dataset.data} label={labels[i]} key={i} />
  ));
}

export function DashboardPrintChartComponent(props) {
  const { chartType, kpiData } = props;
  const SelectedChart = Chart[chartType];

  const chartData = chartDataFactory(SelectedChart.name, kpiData);

  return (
    <DashboardPrintWrapper>
      <InvisibleUntilPrint>
        <Header chartName={chartType} />
        <ChartWrapper>
          <SelectedChart />
        </ChartWrapper>
        <StyledSeparator className="invisi-until-print" />
        {chartData && constructAxisValues(chartData, chartType)}
      </InvisibleUntilPrint>
    </DashboardPrintWrapper>
  );
}

function mapStateToProps(state) {
  return {
    kpiData: dataSelectors.kpiData(state),
  };
}

export const DashboardPrintChart = connect(mapStateToProps)(
  DashboardPrintChartComponent
);
